





































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getAspectRatioFromUrl } from '@/common/ts/common';
import XcqManuscriptFooter from './XcqManuscriptFooter.vue';
import TopTag from './TopTag.vue';
import XcqImage from './XcqImage.vue';

@Component({
  components: {
    XcqManuscriptFooter,
    TopTag,
    XcqImage,
  },
})
export default class XcqManuscriptBigImg extends Vue {
  @Prop({
    default: () => ({
      blockHeaderPic: '',
      blockName: '',
      blockBottomText: '',
      extText1: '',
      data: {},
      list: [],
    }),
  })
  blockInfo!: any;

  @Prop({ default: 349 }) width!: number;

  @Prop({ default: null }) blockDataInfo!: any;

  @Prop({ default: false }) showTop!: boolean;

  @Prop({ default: 0 }) topValue!: number;

  get dataInfo(): any {
    return this.blockDataInfo || this.blockInfo.data;
  }

  get imgWidth(): number {
    return this.width;
  }

  getImageSrc(info: any): string {
    if (info && info.imageUrl && info.imageUrl[0]) {
      return info.imageUrl[0];
    }

    if (info.videoUrl) {
      return `${info.videoUrl}?x-oss-process=video/snapshot,t_0,f_jpg,m_fast,ar_auto`;
    }

    return '';
  }

  hasAspectRatio(url?: string): boolean {
    return !!(url && getAspectRatioFromUrl(url));
  }

  getTopImgHeight(url?: string): number | null {
    if (!url) {
      return null;
    }
    const ratio = getAspectRatioFromUrl(url);
    if (!ratio) {
      return null;
    }
    return Math.round(this.imgWidth / ratio);
  }

  getImgHeightClass(url?: string): string {
    const height = this.getTopImgHeight(url);
    return height ? `height-${height}` : '';
  }

  handleClick(info: any): void {
    this.$emit('clickItem', info.jump, info);
  }
}
